module.exports = __webpack_public_path__ + "img/edit_icon.7bd7dfd5.png";